export default __webpack_public_path__ + "static/media/office1-after2-1440w.39b7a5d9.png";